<template>
  <nav class="navbar navbar-light navbar-expand-lg fixed-top py-3">
    <div class="container-fluid">
      <div class="navbar-brand me-4">
        <div class="d-flex">
          <template v-if="moodysBranded">
            <img
              src="../images/moodys.png"
              alt="Moody's"
              class="hidden-xs"
              style="height: auto; object-fit: contain; max-height: 65px;"
            >
            <div
              class="d-flex flex-column justify-content-start border-start border-dark ps-3 ms-3 hidden-xs"
            >
              <div style="font-size: 1rem; line-height: 1;">
                <small><small><em>Powered by</em></small></small>
              </div>
              <img
                src="../images/logo.png"
                alt="Profound"
                style="height: auto; object-fit: contain; max-height: 43px; max-width: 200px; margin-top: -12px;"
              >
            </div>
          </template>
          <img
            v-else
            src="../images/logo.png"
            alt="Profound"
            class="hidden-xs"
            style="height: auto; object-fit: contain; max-height: 65px;"
          >
        </div>
      </div>
      <div class="h3 mb-0">
        {{ filename }}
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  data: () => ({ filename: null, moodysBranded: false }),
  watch: {
    filename(value) {
      document.title = value;
    },
  },
};
</script>
